import styled from '@emotion/styled';
import { Box, createTheme, Grid, Typography } from '@mui/material';
import { CommentType } from 'APIs/BackstageCommentApi';
import { getNft } from 'APIs/HotAuctionApi';
import { handleConnectWallet } from 'APIs/utils';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { socket } from 'app/socket';
import IC_SHORTCUT from 'assets/icons/ic_shortcut.svg';
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import CommentInput from 'components/atoms/Inputs/CommentInput';
import SuperScriptStr from 'components/atoms/String/SuperScriptStr';
import CardCommentListsWithData from 'components/molecules/Card/CardCommentListsWithData';
import SingleUserRow from 'components/molecules/FollowModal/SingleUserRow';
import BasicModal from 'components/molecules/Modal';
import { selectAuth } from 'features/auth/authSlice';
import { NftBid } from 'interfaces/NftBid.interface';
import NftData from 'interfaces/NftData.interface';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { calculateTimeDifference } from 'utils/time-difference';
import BidModal from 'views/MobileViews/NftAuction/AuctionPage/BidModal';
import BidCard from '../components/BidCard';
import Timer from './components/Timer';
import './style.css';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#ddb930',
      light: '#cccccc3d',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const InsideBottomContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: '10px',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '3rem',
  fontWeight: 'bold',
  marginBottom: '20px',
}));

const ParaText = styled(TitleText)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 'lighter',
  marginBottom: '20px',
  color: '#e5e5e5',
}));

const user0 = require('assets/Profile/buku_default_avatar.png');

const NftDetailsSecondSection = () => {
  const authState = useAppSelector(selectAuth);
  const params = useParams();
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [, setBids] = useState<NftBid[]>([]);
  const [nft, setNft] = useState<NftData>();

  useEffect(() => {
    const fetchNft = async () => {
      const res = await getNft(params.id as string);
      setNft(res.data);
    };
    fetchNft();
    //eslint-disable-next-line
  }, []);

  const handleWalletConnect = async () => {
    if (authState.id && window.ethereum && window.ethereum.isMetaMask) {
      setOpenModal(false);
      await handleConnectWallet(dispatch, authState.id);
    } else {
      setOpenModal(true);
    }
  };

  useEffect(() => {
    socket.on('bidCreated', data => {
      console.log('here!!');
      setBids(bids => [...bids, data as NftBid]);
    });
    //eslint-disable-next-line
  }, [socket]);

  // useEffect(() => {
  //   const getNftBids = async (nftId: number) => {
  //     const nftBidResponse = await findNftBids(nftId);
  //     if (nftBidResponse.data) {
  //       setBids(nftBidResponse.data);
  //     }
  //   };

  //   if (nft && bids.length === 0) {
  //     getNftBids(nft.id);
  //   }
  // }, [nft, bids]);

  return (
    <>
      {nft && (
        <div
          className="explore-page-second-main-container"
          style={{ padding: '0rem 1rem' }}
        >
          <BasicModal
            sx={{ maxWidth: '260px' }}
            open={openModal}
            handleClose={() => setOpenModal(false)}
          >
            <ParaText style={{ color: '#c1c1c1' }}>
              Visit Buku.gg on MetaMask app to link on mobile. Otherwise, you
              can confirm on desktop!
            </ParaText>
          </BasicModal>
          <div className="explore-page-second-container">
            <div className="main-title">{nft.title}</div>
            <div className="shortcut-container">
              Minted on {new Date(nft.createdAt).toDateString()}
              {nft.contractAddress && (
                <a
                  href={`https://mumbai.polygonscan.com/address/${nft.contractAddress}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IC_SHORTCUT}
                    alt="ic-shortcut"
                    className="icon-shortcut"
                  />
                </a>
              )}
            </div>
            <Grid container style={{ alignItems: 'self-end' }}>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'start',
                  flexDirection: 'column',
                  [colortheme.breakpoints.down('lg')]: {
                    alignItems: 'center',
                  },
                }}
              >
                <Box style={{ maxWidth: '350px', width: '100%' }}>
                  <Grid container>
                    <Box
                      sx={{
                        backgroundColor: '#232130',
                        px: 4,
                        borderRadius: 6,
                        display: 'flex',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        my: 1,
                        gap: 2,
                      }}
                    >
                      <span>Owned By</span>
                      <SingleUserRow
                        avatarSrc={nft.user.avatar || user0}
                        username={nft.username}
                        userId={nft.user.id}
                        data={nft.user}
                      />
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: '#232130',
                        px: 4,
                        borderRadius: 6,
                        display: 'flex',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        my: 1,
                      }}
                    >
                      <span>Collected By</span>
                      <SingleUserRow
                        avatarSrc={nft.user.avatar || user0}
                        username={nft.username}
                        userId={nft.user.id}
                        data={nft.user}
                      />
                    </Box>
                  </Grid>
                </Box>

                {/* <div className="explore-second-second-div-info-div">
                <div className="owner-div">
                  <div className="owner-first-div">owned by</div>{' '}
                  <div className="user-div">
                    <div className="user-info-icon-div">
                      <div className="user-info">
                        <img src={UserImage} alt="usr" className="user-image" />
                        <label>@leahx1611</label>
                      </div>
                      <div className="user-icon-container">
                      <img
                          src={UserPlus}
                          alt="user-plus"
                          className="user-plus-icon"
                        />
                      </div>
                    </div>
                    <div className="user-info-icon-div">
                      <div className="user-info">
                        <img src={UserImage} alt="usr" className="user-image" />
                        <label>@johnsea</label>
                      </div>
                      <div className="user-icon-container">
                        <img
                          src={UserPlus}
                          alt="user-plus"
                          className="user-plus-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="explore-second-second-div-info-div">
                <div className="owner-div">
                  <div className="owner-first-div">collector</div>{' '}
                  <div className="user-div">
                    <div className="user-info-icon-div">
                      <div className="user-info">
                        <img src={UserImage} alt="usr" className="user-image" />
                        <label>@leahx1611</label>
                      </div>
                      <div className="user-icon-container">
                        <img
                          src={UserPlus}
                          alt="user-plus"
                          className="user-plus-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'start',
                  [colortheme.breakpoints.down('lg')]: {
                    justifyContent: 'center',
                  },
                }}
              >
                <Box style={{ maxWidth: '400px', width: '100%' }}>
                  <Grid container>
                    <Grid item xs={6}>
                      <ParaText style={{ marginBottom: '.8rem' }}>
                        Reserve price
                      </ParaText>

                      <SuperScriptStr
                        text={
                          nft.highestBid?.bidAmount.toString() ||
                          nft.reservedBid.toString() ||
                          ''
                        }
                        sup={
                          nft.highestBid?.bidAmount || nft.reservedBid
                            ? 'MATIC'
                            : ''
                        }
                        style={{
                          color: '#e5e5e5',
                          fontSize: '1.8rem',
                        }}
                      />
                    </Grid>
                    {nft.endsAt ? (
                      calculateTimeDifference(nft.endsAt) < 0 ? (
                        <Grid item xs={6}>
                          <ParaText style={{ marginBottom: '.8rem' }}>
                            Auction has ended
                          </ParaText>
                        </Grid>
                      ) : (
                        <Grid item xs={6}>
                          <ParaText style={{ marginBottom: '.8rem' }}>
                            Auction ends in
                          </ParaText>
                          <Timer nft={nft} />
                        </Grid>
                      )
                    ) : (
                      <Grid item xs={6}>
                        <ParaText style={{ marginBottom: '.8rem' }}>
                          Place a bid to start auction
                        </ParaText>
                      </Grid>
                    )}
                  </Grid>

                  {authState.id &&
                  authState.walletAddress &&
                  // (nft.endsAt || !nft.endsAt)
                  //  &&
                  authState.username !== nft.username ? (
                    !nft.endsAt ||
                    (calculateTimeDifference(nft.endsAt) > 0 && (
                      <BidModal setNft={setNft} nft={nft}>
                        <BigNormalButton
                          color="yellow"
                          text="Place Bid"
                          style={{ padding: '1.4rem', margin: '1rem 0rem' }}
                        />
                      </BidModal>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <BigNormalButton
                        text={'Link Meta Mask'}
                        color="yellow"
                        style={{
                          padding: '1.4rem',
                          margin: '1rem 0rem',
                        }}
                        disabled={authState.walletAddress ? true : false}
                        onClick={() => {
                          handleWalletConnect();
                        }}
                      />
                    </Grid>
                  )}
                  <Box
                    sx={{
                      backgroundColor: '#232130',
                      px: 4,
                      borderRadius: 6,
                      display: 'flex',
                      alignItems: 'center',
                      whiteSpace: 'nowrap',
                      my: 1,
                      gap: 2,
                    }}
                  >
                    <span>Listed By</span>
                    <SingleUserRow
                      avatarSrc={nft.user.avatar || user0}
                      username={nft.username}
                      userId={nft.user.id}
                      data={nft.user}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <div className="description-div">
              <div className="desc-title">Description</div>
              <div className="desc-caption-title">About {nft.title}</div>
              <div className="desc-body">{nft.description}</div>
            </div>

            <div className="history-title">History</div>
            <BidCard
              avatar={nft.user.avatar}
              createdAt={nft.createdAt}
              username={nft.username}
              price={nft.reservedBid}
              title="Listed by"
            />
            {nft.bids?.map(bid => (
              <BidCard
                key={bid.id}
                avatar={bid.user.avatar}
                createdAt={bid.createdAt}
                username={bid.user.name}
                price={bid.bidAmount}
                title="Bid placed by"
              />
            ))}

            <div style={{ margin: '3.5rem 0rem' }}>
              <div className="history-title">
                Comments ({nft.comments ? nft.comments.length : 0})
              </div>
              <section
                className="comment-section scrollbar-hidden"
                style={{ margin: '1rem' }}
              >
                <div>
                  {nft.comments ? (
                    nft.comments.map((item, index) => {
                      if (!item.parent)
                        return (
                          <CardCommentListsWithData
                            nft={nft}
                            data={item}
                            key={item.id}
                            type={CommentType.NFT}
                          />
                        );
                      else return <></>;
                    })
                  ) : (
                    <></>
                  )}
                  <InsideBottomContent>
                    <CommentInput
                      ownerId={nft.user.id}
                      postId={`${id}`}
                      type={CommentType.NFT}
                      nft={nft}
                    />
                  </InsideBottomContent>
                </div>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NftDetailsSecondSection;
